import { CacheKey } from "@/modules/cache/constants";

export const METRICS_GLOBAL_SCOPE_ID = "global-scope";

const GLOBAL_SCOPE_KEYS = new Set<CacheKey>([
  CacheKey.MetricsSegmentAnonymousId,
  CacheKey.MetricsGoogleAnalyticsClientId,
  CacheKey.MetricsGoogleAnalyticsSessionId,
  CacheKey.MetricsMetadataString,
  CacheKey.MetricsElectronAppInfo,
]);

type ResolveCacheScopeIdArgs<TCacheKey extends CacheKey> = {
  cacheKey: TCacheKey;
  resolveDefaultScopeId: () => Promise<string | null>;
};

export const resolveCacheScopeId = async <TCacheKey extends CacheKey>({
  cacheKey,
  resolveDefaultScopeId,
}: ResolveCacheScopeIdArgs<TCacheKey>): Promise<string | null> => {
  if (GLOBAL_SCOPE_KEYS.has(cacheKey)) {
    return METRICS_GLOBAL_SCOPE_ID;
  }

  return resolveDefaultScopeId();
};
